export const paymentMethodNote = 'To proceed, please add a credit or debit card. \nIf your copay is $0, you won\'t be charged.';
export const paymentMethodSuccessNote = 'Monthly payments will be begin once your first MedBox ships.';